<script setup lang="ts">
  import { useScroll } from '@vueuse/core'

  const { y: scrollY } = useScroll(document)
  const showHeight = 2500
  const show = computed(() => scrollY.value > showHeight)

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })
</script>
<template>
  <div
    v-if="show"
    id="back-to-top"
    class="container sticky bottom-0 right-0 z-20 hidden w-full transition md:flex"
    @click="scrollToTop"
  >
    <div
      class="absolute bottom-6 flex size-14 cursor-pointer items-center justify-center rounded-full bg-white text-bt-blue-ui shadow-md md:right-5 lg:right-0"
    >
      <Icon name="common/arrow-upward" />
    </div>
  </div>
</template>
